import type { FC } from 'react';
import { Button, ModalBody, ModalFooter, SmallModal } from '@george-labs.com/design-system';
import { useEffect } from 'react';

import { Translation, t } from '@luna/i18n';
import { useNotifications } from '@shared/snackbar';

import { useImageUploadContext } from '../ImageUploadContext';
import { ImageUploadModal } from '../ImageUploadService';

type Props = {
    showResultAsNotification?: boolean;
};
export const ImageUploadErrorModal: FC<Props> = ({ showResultAsNotification }) => {
    const { currentModal, closeModal } = useImageUploadContext();
    const { displayError } = useNotifications('image-upload');

    useEffect(() => {
        if (currentModal === ImageUploadModal.ErrorModal && showResultAsNotification) {
            closeModal();
            displayError(t('main.imageUpload.errorModalBody'));
        }
    }, [currentModal]);

    if (currentModal !== ImageUploadModal.ErrorModal) {
        return null;
    }
    return (
        <SmallModal
            isOpen
            appear
            variant={SmallModal.VARIANT.ERROR}
            title={t('main.imageUpload.errorModalTitle')}
        >
            <ModalBody data-cy="user-profile-image-service-unavailable-modal">
                <Translation t="main.imageUpload.errorModalBody" component="p" />
            </ModalBody>
            <ModalFooter>
                <Button onClick={closeModal}>{t('app.close')}</Button>
            </ModalFooter>
        </SmallModal>
    );
};
